import { useEffect, useRef, useState } from "react";

/** Automatic motion stays off during SSR and in browsers without observation.
 * Manual gallery navigation remains available in those environments. */
export function useAuctionVisibility<ElementType extends HTMLElement>() {
  const ref = useRef<ElementType>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const element = ref.current;
    // biome-ignore lint/suspicious/noUnnecessaryConditions: React assigns this ref after rendering.
    if (!(element && "IntersectionObserver" in window)) {
      return;
    }
    let intersecting = false;
    const update = () => setVisible(intersecting && !document.hidden);
    const observer = new IntersectionObserver(([entry]) => {
      intersecting = Boolean(
        entry?.isIntersecting && entry.intersectionRatio > 0
      );
      update();
    });
    observer.observe(element);
    document.addEventListener("visibilitychange", update);
    return () => {
      observer.disconnect();
      document.removeEventListener("visibilitychange", update);
    };
  }, []);
  return { ref, visible };
}
